export const DEFAULT = "#b6b6b6";
export const DRAFT = "#807f80";
export const TESTING = "#e3b748";
export const PUBLISH = "#6fb973";
export const REVIEW = "#4b4dcb";
export const REJECT = "#e74c3c";